import React, { useState } from "react";
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from "react-router-dom";
import { Form, Button, Alert } from "react-bootstrap";

function Login({ onLoginSuccess } ) {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [hideLogin, setHideLogin] = useState(false);
  const navigate = useNavigate();

  const TFCBT_URL = process.env.REACT_APP_TFCBT_URL || 'http://localhost:3004';

  const errorMessages = {
    ineligible: {
      message: "You must complete TF-CBTWeb2.0 before taking this course.",
      link_text: 'Return to TF-CBTWeb2.0',
      link: TFCBT_URL,
      type: 'ineligible'
    },
    group_administrator: {
      message: "Organizational purchasing is not currently available for CTGWeb2.0.  Contact TF-CBT customer service for assistance.",
      link_text: 'Return to TF-CBTWeb2.0',
      link: TFCBT_URL,
      type: 'group_administrator'
    },
    invalid_credentials: {
      message: 'Invalid email or password. Please try again.',
      links: [
        { text: 'Forgot Password?', url: `${TFCBT_URL}/en/users/password/new` },
        { text: 'Register for an account', url: `${TFCBT_URL}/en/users/sign_up` }
      ],
      type: 'invalid_credentials'
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const response = await login(email, password);
    if (response.success) {
      onLoginSuccess();
      navigate("/");
    } else {
      const errorConfig = errorMessages[response.message]
      setError(errorConfig);
      if (response.message === 'group_administrator') {
        setHideLogin(true)
      }
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {error && (
        <Alert variant="danger">
          {error.message}
          {error.link && !error.links && (
            <>
              <br />
              <a href={error.link} target="_blank" rel="noopener noreferrer">
              {error.link_text}
              </a>
            </>
          )}
          {error.links && error.links.map((link, index) => (
            <React.Fragment key={index}>
              <br />
              <a href={link.url} target="_blank" rel="noopener noreferrer">
              {link.text}
              </a>
            </React.Fragment>
          ))}
        </Alert>
      )}
      {hideLogin === false && (
        <>
          <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control
              type="email"
              placeholder="Email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Form.Group>
          <div className="d-grid">
            <Button className="login-button" type="submit">
              Log In
            </Button>
          </div>
        </>
      )}
    </Form>
  );
}

export default Login;
